
import {
  HTTP
} from '../utils/http.js'

const http = new HTTP();

//直播会议详情
export const postLiveMeetDetail = params => {
  return http.post("/api2/v1/app/live-meet/detail", params);
};

//获取直播协议--弹窗（后台设置协议，获取到则显示直播协议）
export const postProtocol = params => {
  return http.post("/api2/v1/app/live-meet/protocol", params);
};

//获取 JSSSDK 配置参数
export const postFetchSdkParams = params => {
  return http.post("/api/v1/app/wechat/fetch-sdk-params", params);
};

//发送短信验证码
export const postSendSmsCode = params => {
  // return http.post("/api/v1/app/common/send-sms-code", params);
  // return http.post("/api/v1/app/common/yunicu_auth", params); //外包验证码
  return http.post("/api/v1/app/common/yunicu_auth", params); // yunicu内部验证码
};

//检查直播是否登录或缴费
export const postCheckLoginPay = params => {
  return http.post("/api2/v1/app/live-meet/check_login_pay", params);
};

//登录
export const postLogin = params => {
  return http.post("/api/v1/app/common/live-h5-login", params);
};

//注册
export const postRegister = params => {
  return http.post("/api/v1/app/common/live-h5-register", params);
};

//获取用户信息
export const postUserInfo = params => {
  return http.post("/api2/v1/app/live-meet/user_info", params);
};

//添加直播会议观看记录
export const postAddWatchRecord = params => {
  return http.post("/api2/v1/app/live-meet/add_watch_record", params);
};

//添加直播会议上报记录
export const postAddReportedRecord = params => {
  return http.post("/api2/v1/app/live-meet/add_reported_record", params);
};

//添加直播人员记录
export const postAddMember = params => {
  return http.post("/api2/v1/app/live-meet/add_member", params);
};

//修改我的中奖信息
export const postUpdateRaffleWinning = params => {
  return http.post("/api2/v1/app/live-meet/update_raffle_winning", params);
};

//获取我的获奖详情
export const postGetRaffleWinning = params => {
  return http.post("/api2/v1/app/live-meet/get_raffle_winning", params);
};

//添加中奖记录
export const postAddRaffleWinning = params => {
  return http.post("/api2/v1/app/live-meet/add_raffle_winning", params);
};

//添加抽奖次数记录
export const postAddRaffleRecord = params => {
  return http.post("/api2/v1/app/live-meet/add_raffle_record", params);
};

//抽奖环节详情
export const postPrizeDetail = params => {
  return http.post("/api2/v1/app/live-meet/prize_detail", params);
};

//获取注册协议
export const getProtocol = params => {
  return http.get("/api/v1/app/common/protocol", params);
};

//直播会议详情-目录列表接口
export const postMettingDetail = params => {
  return http.post("/api2/v1/app/live-meet/metting_detail", params);
};

//添加预约记录
export const postAddSubscribeRecord = params => {
  return http.post("/api2/v1/app/live-meet/add_subscribe_record", params);
};

//完善登录信息
export const postUpdateMyInfo = params => {
  return http.post("/api/v1/app/common/update_my_info", params);
};

//直播添加问题与答案记录
export const postAddQuestionAnswer = params => {
  return http.post("/api2/v1/app/live-meet/add_question_answer", params);
};

//获取开场信息
export const postLiveBeginImage = params => {
  return http.post("/api2/v1/app/live-meet/live_begin_image", params);
};

//身份列表
export const postIdentityList = params => {
  return http.post("/api/v1/app/common/identity_list", params);
};

//学校列表
export const getAuthSchools = params => {
  return http.get("/api/v1/app/auth/schools", params);
};

//职称列表
export const getAuthJobTitles = params => {
  return http.get("/api/v1/app/auth/jobTitles", params);
};

//科室列表
export const getAuthOffices = params => {
  return http.get("/api/v1/app/auth/offices", params);
};

//获取学校推荐
export const getSchoolRecommend = params => {
  return http.get("/api/v1/app/common/school_recommend", params);
};

//获取推荐医院
export const getHospitalRecommend = params => {
  return http.get("/api/v1/app/common/hospital_recommend", params);
};

//获取省级数据
export const getProvincesRecommend = params => {
  return http.get("/api/v1/app/common/provinces", params);
};

//获取市级数据
export const getCitysRecommend = params => {
  return http.get("/api/v1/app/common/cities", params);
};

//获取医院数据
export const getAuthHospitals = params => {
  return http.get("/api/v1/app/common/hospitals", params);
};

//发送邮箱验证码
export const postSendEmailCode = params => {
  return http.post("/api2/v1/app/common/sendEmailCode", params);
};

//邮箱登录
export const postEmailLogin = params => {
  return http.post("/api2/v1/app/common/emailLogin", params);
};

//上传图片
export const postUpload = (data, params) => {
  return http.post("/api/v1/app/common/upload", data, params, {
    'Content-Type': 'multipart/form-data;charset=UTF-8'
  });
};

//添加投诉
export const postAddComplain = params => {
  return http.post("/api2/v1/app/complain/addComplain", params);
};

//添加反馈意见
export const postAddFeedBack = params => {
  return http.post("/api2/v1/app/complain/addFeedBack", params);
};

//多会场-获取大会涉及到的地点
export const getConventionSites = params => {
  return http.get(`/api/v1/app/conventions/${params.id}/sites`, params);
};

//多会场-获取大会详情（日期）/以及获取大会的要求时长和实际观看时长
export const getConventionDetail = params => {
  return http.get(`/api/v1/app/conventions/${params.id}`, params);
};

//多会场-根据会议地点和日期获取会议日程
export const getConventionSchedulesDetail = params => {
  return http.get(`/api/v1/app/conventions/${params.id}/sites/${params.site_id}/schedules_live`, params);
};

//微信公众号登录
export const wechatOfficeLogin = params => {
  return http.post("/api/v1/app/common/wechatOfficeLogin", params);
};

//微信登录绑定手机号
export const wechatBindTel = params => {
  return http.post("/api/v1/app/common/wechatBindTel", params);
};

//获奖者列表
export const winningList = params => {
  return http.post("/api2/v1/app/live-meet/winning_list", params);
};

//参与者列表
export const participantList = params => {
  return http.post("/api2/v1/app/live-meet/participant_list", params);
};


//多会场-获取大会详情（日期）/以及获取大会的要求时长和实际观看时长
export const getYichiList = params => {
  return http.get(`/user/live/stream`, params);
};
